<div class="pm-color-dot" (click)="colorOverlayOpen = !colorOverlayOpen" [style.background-color]="color" cdkOverlayOrigin #colorTrigger="cdkOverlayOrigin"></div>

<ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="colorTrigger" [cdkConnectedOverlayOpen]="colorOverlayOpen" cdkConnectedOverlayHasBackdrop="true" (backdropClick)="onColorClose()">
  <color-chrome [color]="color" (onChangeComplete)="colorChange($event)" disableAlpha="true"></color-chrome>
</ng-template>
